




import { Component, Vue } from 'vue-property-decorator';
import '../../../node_modules/firebaseui/dist/firebaseui.css';
import { uiConfig } from './../../firebase.config';

@Component({
  components: {},
  mounted() {
    // @ts-ignore
    this.fireUi.start('#auth-container', uiConfig);
  },
})
export default class SignIn extends Vue {
  get fireUi(): firebaseui.auth.AuthUI {
    return this.$store.state.fireUi;
  }
}
